var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// tslint:disable:no-null-keyword
import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { IdStyles } from "../../../less/IdStyles";
import { selectConstructionXpBuffAmount } from "../../../selectors/selectBuffsInfo";
import { selectBuildingConstructionTime, selectBuildingHappiness, selectBuildingWorkers, selectBuildingXpInfo, selectSelectedBuildingInfo, } from "../../../selectors/selectExistingBuildingInfo";
import { selectAdventureLevel, selectPlayerLevel } from "../../../selectors/selectPlayerLevelInfo";
import { actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionBuildingsStartPurchase } from "./actionBuildings";
import { BuildingInformation } from "./BuildingInformation";
import { BuildingMaxed } from "./BuildingMaxed";
import { BuildingRequirements } from "./BuildingRequirements";
import { BuildingStats } from "./BuildingStats";
import { ButtonBuyBuilding } from "./ButtonBuyBuilding";
var DetailViewBuildingsDOM = /** @class */ (function (_super) {
    __extends(DetailViewBuildingsDOM, _super);
    function DetailViewBuildingsDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getBuildingRequirementInfo = function () {
            var item = _this.props.item;
            var _a = _this.props, playerLevel = _a.playerLevel, adventureLevel = _a.adventureLevel, buildingInfo = _a.buildingInfo, onBuild = _a.onBuild, workers = _a.workers;
            var isBuildingMaxed = item.existingCount && item.existingCount >= item.maxAmount;
            return isBuildingMaxed ? (React.createElement("div", { className: "flex " + IdStyles.BuildMenuRequirementSection },
                React.createElement(BuildingMaxed, null))) : (React.createElement("div", { className: "building-detail__requirement " + IdStyles.BuildMenuRequirementSection },
                React.createElement(BuildingRequirements, { workers: workers, playerLevel: playerLevel, adventureLevel: adventureLevel, requiredPlayerLevel: item.requiredPlayerLevel, requiredAdventurerLevel: item.requiredAdventurerLevel }),
                React.createElement(ButtonBuyBuilding, { item: item, buildingInfo: buildingInfo, onBuild: onBuild })));
        };
        return _this;
    }
    DetailViewBuildingsDOM.prototype.render = function () {
        var _a = this.props, item = _a.item, workers = _a.workers, happiness = _a.happiness, xpInfo = _a.xpInfo, constructionTime = _a.constructionTime, getConstructionXpBuffAmount = _a.getConstructionXpBuffAmount, openInfoMenu = _a.openInfoMenu;
        var buffXpAmount = xpInfo
            ? Long.fromValue(getConstructionXpBuffAmount(xpInfo.amount))
            : Long.ZERO;
        if (item) {
            var buildingRequirement = this.getBuildingRequirementInfo();
            return (React.createElement("div", { className: "flex flex--guts " + IdStyles.DetailViewWrapper },
                React.createElement("div", { className: "building-detail " + IdStyles.DetailView },
                    React.createElement(BuildingInformation, { item: item, onInfoButton: openInfoMenu },
                        React.createElement(BuildingStats, { workers: workers, item: item, constructionTime: constructionTime, happiness: happiness, xpInfo: xpInfo, buffXpAmount: buffXpAmount })),
                    buildingRequirement)));
        }
        return null;
    };
    return DetailViewBuildingsDOM;
}(React.PureComponent));
var mapState = function (state) {
    var level = 0;
    var buildingInfo = selectSelectedBuildingInfo(state);
    var buildingTypeId = buildingInfo ? buildingInfo.balancing.id : -1;
    return {
        adventureLevel: selectAdventureLevel(state),
        buildingInfo: buildingInfo,
        constructionTime: selectBuildingConstructionTime(state, buildingTypeId, level),
        getConstructionXpBuffAmount: function (amount) {
            return selectConstructionXpBuffAmount(state, amount);
        },
        happiness: selectBuildingHappiness(state, buildingTypeId, level),
        playerLevel: selectPlayerLevel(state),
        workers: selectBuildingWorkers(state, buildingTypeId, level),
        xpInfo: selectBuildingXpInfo(state, buildingTypeId, level),
    };
};
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onBuild: actionBuildingsStartPurchase,
        openInfoMenu: function () { return actionModalOpen(IdModal.BuildingInfo); },
    }, dispatch);
};
export var DetailViewBuildings = connect(mapState, mapDispatch)(DetailViewBuildingsDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/DetailViewBuildings.tsx
// module id = 2733
// module chunks = 3